import UIFetchService from '../Service/UIFetchService';
import AuthFetchService from '../Service/AuthFetchService';
import { toThousands } from '../Service/Utils'

import React, {useState} from 'react';
import { Modal, Button, Table, Tag, Row, Col, Input, Space, Pagination, message, Menu, Tooltip, Checkbox, Switch} from 'antd';
import {
    ExclamationCircleOutlined, RedoOutlined, CheckCircleTwoTone, SyncOutlined, WarningTwoTone, ClockCircleOutlined,
    EditOutlined, CloseOutlined
} from '@ant-design/icons';
import { isNotEmpty,isEmpty } from '../Service/Utils';

// const stateNamedMap = {
//     'OK': ['计算完成', 'green'],
//     'FAIL': ['计算失败', 'red'],
//     'RUNNING': ['计算中', 'yellow'],
//     'INIT': ['未开始', 'gray']
// };

const scheduleTypeNamedMap = {
    'ONE_SHOT': '单次计算',
    'DAILY': '每日更新'
}

class UserClusteringList extends React.Component {

    confKey = 'user.clustering.cfg';

    constructor() {
        super();
        const rawConf = localStorage.getItem(this.confKey);
        let cfg = {
            ownsOnly: false,
        };
        if (isNotEmpty(rawConf)) {
            cfg = JSON.parse(rawConf);
        }
        this.state = {
            definitions: [],
            totalOfDefinitions: 0,
            pageNo: 1,
            pageSize: 20,
            searchKey: '',
            tableHeight: document.body.clientHeight - 230,
            contextMenu: {
                x: 0,
                y: 0,
                popup: false
            },
            ...cfg
        };
    }

    componentDidMount() {
        this.fetchPaginationDefinitions(1, this.state.pageSize);
        AuthFetchService.appendLog('用户分群');
    }

    render() {
        return <>
            <Row style={{ margin: '12px 0 0 0' }}>
                <Col flex='300px' style={{ alignSelf: 'center' }}>
                        <Input.Search
                            title="搜索"
                            placeholder="请输入人群名称/创建人搜索"
                            onChange={(e) => {
                                this.fetchPaginationDefinitions(1, this.state.pageSize, e.target.value);
                                this.setState({ pageNo: 1, searchKey: e.target.value });
                            }}
                            onSearch={() => this.fetchPaginationDefinitions(this.state.pageNo, this.state.pageSize, this.state.searchKey, this.state.ownsOnly)}
                        />
                </Col>
                <Col style={{ alignSelf: 'center', margin: '0 0 0 10px' }}>
                    <Checkbox
                        checked={this.state.ownsOnly}
                        onChange={({ target: { checked } }) => this.fetchPaginationDefinitions(this.state.pageNo, this.state.pageSize, this.state.searchKey, checked)}
                    >只看我的</Checkbox>
                </Col>
                <Col flex="auto"></Col>
                <Col style={{margin: '0 40px 0 0'}}>
                    <Space>
                        <Button
                                type="default"
                                shape="circle"
                                icon={<RedoOutlined />}
                                onClick={() => this.fetchPaginationDefinitions(this.state.pageNo, this.state.pageSize, this.state.searchKey, this.state.ownsOnly)}
                            />
                        <Button
                        type="primary"
                        onClick={this.props.onCreateClustering}>新建分群</Button>
                    </Space>
                    
                </Col>
            </Row>
            
            <div style={{ height: '10px' }} />
            <Row>
                <Col>
                    <Table
                        dataSource={this.state.definitions}
                        pagination={{
                            total: this.state.totalOfDefinitions,
                            current: this.state.pageNo,
                            pageSize: this.state.pageSize,
                        }}
                        size="small"
                        scroll={{ y: this.state.tableHeight }}
                        onChange={(pagination, filters) => {
                            this.fetchPaginationDefinitions(pagination.current,pagination.pageSize, this.state.searchKey,this.state.ownsOnly, filters)
                        }}
                    >
                        <Table.Column
                            title=""
                            dataIndex="state"
                            key="state"
                            width={10}
                            render={(value, record) => {
                                switch (value) {
                                    case 'OK':
                                        return <CheckCircleTwoTone twoToneColor="#52c41a" />
                                    case 'FAIL':
                                        return <Tooltip  title={record.logs}><WarningTwoTone twoToneColor="#fa541c"/></Tooltip>
                                    case 'RUNNING':
                                        return <SyncOutlined spin style={{ color: '#fadb14' }} />
                                    case 'INIT':
                                        return <ClockCircleOutlined />
                                    default:
                                        return <></>
                                }
                            }}
                        />

                        <Table.Column
                            title="名称"
                            dataIndex="name"
                            key="name"
                            //fixed="left"
                            width={70}
                            ellipsis
                            render={(value, record) =>
                                this.allowDefinitionOperating(record)
                                    ? <a onClick={() => this.props.onEditClustering(record.id)}>{value}</a>
                                    : <span style={{ color: 'gray' }}>{value}</span>}
                        />
                        <Table.Column
                            title="API"
                            dataIndex="appKeyId"
                            key="appKeyId"
                            width={30}
                            render={value => value ? <Tag color="#52c41a">{value}</Tag> : <></>}
                        />
                        <Table.Column
                            title="人数"
                            dataIndex="result"
                            key="result"
                            align="right"
                            width={50}
                            render={(_, record) => {
                                if (record.yesterdayDau > 0) {
                                    return <Tooltip title="昨日活跃/人群总数">
                                        <span style={{ color: '#fa541c', fontSize: 12 }} >{toThousands(record.yesterdayDau)}</span>
                                        <span style={{ fontSize: 12 }}>/{toThousands(record.result)}</span>
                                    </Tooltip>
                                } else {
                                    return <span>{toThousands(record.result)}</span>
                                }
                            }}
                        />
                        <Table.Column
                            title="创建者"
                            dataIndex="ownerName"
                            key="ownerName"
                            width={25}
                        />
                        <Table.Column
                            title="创建时间"
                            dataIndex="createdAt"
                            key="createdAt"
                            width={50}
                        />
                        <Table.Column
                            title="数据更新时间"
                            dataIndex="updatedAt"
                            key="updatedAt"
                            width={50}
                        />
                        <Table.Column
                            title="计算方式"
                            dataIndex="scheduleType"
                            key="scheduleType"
                            width={30}
                            filters={[{ text: "单次计算", value: "ONE_SHOT" }, { text: "每日更新", value: "DAILY" }]}
                            // onFilter={(value, rd) => {
                            //     if (isEmpty(rd.scheduleType)) {
                            //         return false;
                            //     }
                            //     return rd.scheduleType === value;
                            // }}
                            render={(_, record) => <span>{scheduleTypeNamedMap[record.scheduleType]}</span>}
                        />
                        <Table.Column
                            title="状态"
                            dataIndex="status"
                            key="status"
                            width={30}
                            ellipsis
                            filters={[{ text: "使用中", value: 1 }, { text: "已停用", value: 0 }]}
                            // onFilter={(value, rd) => {
                            //     if (isEmpty(rd.status)) {
                            //         return false;
                            //     }
                            //     return rd.status === value;
                            // }}
                            render={(status, record) => 
                                <Switch checkedChildren="使用中" unCheckedChildren="已停用" checked={status} disabled={!this.allowDefinitionOperating(record)}
                                    onChange={(c) => this.switchStatus(record, c ? 1:0)}/>}
                        />
                        <Table.Column
                            title="人群洞察"
                            dataIndex="clusterInsight"
                            key="clusterInsight"
                            width={30}
                            render={(_, record) => {
                                return <Button type="primary" shape="round" size="small" style={{fontSize: '12px'}} ghost onClick={() => window.location = `/user_profile/clustering/${record.id}/analysis`}>人群洞察</Button>
                            }}
                        />
                        <Table.Column
                            title="操作"
                            dataIndex="action"
                            key="action"
                            width={60}
                            render={(_, record) => {
                                return <Space> 
                                    <Button type="link" onClick={() => this.clusteringDefinitionDidInvalid(record)} style={{padding:'4px 5px'}} disabled={!(this.allowDefinitionOperating(record) && record.status === 1)}>重跑</Button>
                                    <Button type="link" onClick={() => this.props.onEditClustering(record.id)}  style={{padding:'4px 5px'}} disabled={!this.allowDefinitionOperating(record)}>编辑</Button>
                                    <Button type="link" onClick={() => this.clusteringDefinitionDidRemoved(record)} danger  style={{padding:'4px 5px'}} disabled={!this.allowDefinitionOperating(record)}>删除</Button>
                                </Space>
                            }}
                        />
                    </Table>
                </Col>
                {this.state.contextMenu.popup && <Menu
                    style={{
                        position: 'fixed',
                        top: this.state.contextMenu.x,
                        left: this.state.contextMenu.y
                    }}
                >
                    <Menu.Item>
                        <a>aaa</a>
                    </Menu.Item>
                </Menu>}
            </Row>
        </>
    }

    definitionsPageNoDidChanged = (pageNo) => {
        if (pageNo !== this.state.pageNo) {
            this.setState({ pageNo: pageNo });
            //this.fetchClusterUsers(pageNo, this.state.pageSize);
            this.fetchPaginationDefinitions(pageNo, this.state.pageSize, this.state.searchKey)
        }
    }

    definitionsPageSizeDidChanged = (pageNo, pageSize) => {
        //console.log(`on pageSize ${pageNo} ${pageSize}`);
        this.setState({ pageNo: pageNo, pageSize: pageSize });
        //this.fetchClusterUsers(pageNo, pageSize);
        this.fetchPaginationDefinitions(pageNo, pageSize, this.state.searchKey)
    }

    allowDefinitionOperating(record) {
        return (AuthFetchService.uid === record.ownerId || AuthFetchService.allow('datap:admin')) &&
            (record.state === 'OK' || record.state === 'FAIL' || record.state === null)
    }

    async clusteringDefinitionDidRemoved(definition) {
        const refresh = () => {
            message.info(`分群"${definition.name}"已删除`);
            this.fetchPaginationDefinitions(this.state.pageNo, this.state.pageSize);
        };
        Modal.confirm({
            title: `是否要删除分群：“${definition.name}“?`,
            icon: <ExclamationCircleOutlined />,
            content: '删除分群',
            onOk() {
                UIFetchService.method('DELETE', `/api/v1/user_clustering/definitions/${definition.id}`)
                    .then(() => refresh())

            },
            onCancel() {
                //console.log('Cancel');
            },
        });
    }

    async clusteringDefinitionDidInvalid(definition) {
        const refresh = () => {
            message.info(`分群"${definition.name}"今日数据已删除`);
            this.fetchPaginationDefinitions(this.state.pageNo, this.state.pageSize);
        };
        Modal.confirm({
            title: `是否要重跑分群：“${definition.name}“?`,
            icon: <ExclamationCircleOutlined />,
            content: '此操作将会删除今日数据，触发分群重新计算',
            onOk() {
                UIFetchService.method('PATCH', `/api/v1/user_clustering/definitions/${definition.id}`)
                    .then(() => refresh())

            },
            onCancel() {
                //console.log('Cancel');
            },
        });
    }

    async fetchPaginationDefinitions(pageNo, pageSize, searchKey, ownsOnly, filters) {
        if(ownsOnly === undefined){
            ownsOnly = this.state.ownsOnly
        }
        
        this.saveCfg(ownsOnly);
        const url = `/api/v1/user_clustering/definitions?pageNo=${pageNo}&pageSize=${pageSize}` +
            `&searchKey=${((searchKey === undefined) ? '' : encodeURI(searchKey))}` +
            `&ownsOnly=${((ownsOnly === undefined) ? '' :ownsOnly)}`
            + `&filters=${((filters === undefined) ? '' : encodeURI(JSON.stringify(filters)))}`;
        const page = await UIFetchService.get(url);
        this.setState({ definitions: page.items, totalOfDefinitions: page.total , ownsOnly: ownsOnly, pageNo: pageNo, pageSize: pageSize});
    }

    async switchStatus(definition, status) {
        UIFetchService.method('PATCH', `/api/v1/user_clustering/definitions/${definition.id}/switchStatus?status=${status}`)
            .then((result) => {
                if (result != null) {
                    message.success("修改状态成功")
                    this.setState(({ items }) => {
                        definition.status = status
                        return { items };
                    })
                }
            })     
    }
    saveCfg(ownsOnly) {
        const cfg = { ownsOnly: ownsOnly};
        localStorage.setItem(this.confKey, JSON.stringify(cfg));
    }
}

export default UserClusteringList;